import {
  CREATE_CHAT,
  GET_CHAT_ROOMS,
  GET_CHATS,
  UPDATE_CHAT,
} from "@/views/csr/store/typeDefs/chat";
import chatApiService from "@/views/csr/services/api/chat";

const chatStoreModule = {
  actions: {
    async [GET_CHAT_ROOMS](_, { page, sort, search, status }) {
      try {
        const result = await chatApiService.getRooms({
          page,
          sort,
          search,
          status,
        });
        if (!result) return [];
        return result.data;
      } catch (_) {
        return [];
      }
    },

    async [GET_CHATS](_, { slug, page }) {
      try {
        const result = await chatApiService.getChats(slug, page);
        if (!result) return [];
        return result.data;
      } catch (_) {
        return [];
      }
    },

    async [CREATE_CHAT](_, { slug, message }) {
      try {
        const result = await chatApiService.createChat(slug, message);
        if (!result) return result;
        return result;
      } catch (_) {
        return null;
      }
    },

    async [UPDATE_CHAT](_, { roomID, status }) {
      try {
        const formData = new FormData();
        if (status) formData.append("status", status);
        formData.append("_method", "PUT");
        const result = await chatApiService.updateRoom(roomID, formData);
        if (!result) return null;
        return {
          success: true,
          data: result,
        };
      } catch (_) {
        return {
          success: false,
          data: null,
        };
      }
    },
  },
};

export default chatStoreModule;
